<template>
  <PropertyManagerScreenHeader />

  <v-main>
    <v-container fluid class="d-flex flex-column min-height container">
      <AdminNavbar v-model="navbarStore.showNavbar" />

      <div class="flex-grow-1 content">
        <NuxtPage />

        <PropertyManagerScreenFooter v-if="!hideFooter" />
      </div>
    </v-container>
  </v-main>
</template>

<script setup>
const navbarStore = useNavbarStore();
const temporary = ref(false);
const route = useRoute();

const hideFooter = computed(() => route.path.includes('adm-030'));

onMounted(async () => {
  await nextTick();
  handleResize();
  window.addEventListener('resize', handleResize);
});

const handleResize = () => {
  if (window.innerWidth < 1024) {
    if (navbarStore.showNavbar) {
      navbarStore.showNavbar = false;
    }
    temporary.value = true;
  } else {
    navbarStore.showNavbar = true;
    temporary.value = false;
  }
};

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style scoped>
.container {
  height: 0px;
  padding: 0px;
}
.content {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 16px;
}
</style>
